"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _constants = require("./constants");
/**
 *
 * @param func - the throttled function
 * @param limit - invoke interval limit
 * @returns {(function(): void)|*}
 */
var throttle = function throttle(func, limit) {
  var lastFunc;
  var lastRan;
  return function () {
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    // @ts-ignore
    var context = this;
    if (!lastRan) {
      func.apply(context, args);
      lastRan = Date.now();
    } else {
      clearTimeout(lastFunc);
      lastFunc = setTimeout(function () {
        if (Date.now() - lastRan >= limit) {
          func.apply(context, args);
          lastRan = Date.now();
        }
      }, limit - (Date.now() - lastRan));
    }
  };
};
var monitorUserActivity = function monitorUserActivity(runWhenUserActive, runWhenUserIdle) {
  var timer;
  var didRunUserActiveFunction = false;
  var TIME_TO_IDLE_IN_MILLISECONDS = _constants.HALF_AN_HOUR;
  var LIMIT = 1000;
  var ACTIVITY_INDICATION_EVENTS = ['load', 'mousemove', 'mousedown', 'touchstart', 'click', 'keypress'];
  function resetTimer() {
    if (!didRunUserActiveFunction) {
      runWhenUserActive();
      didRunUserActiveFunction = true;
    }

    // Clear the previous timeout
    clearTimeout(timer);

    // Set a new timeout
    timer = setTimeout(function () {
      didRunUserActiveFunction = false;
      runWhenUserIdle();
    }, TIME_TO_IDLE_IN_MILLISECONDS);
  }

  // Define the events that would reset the timer
  ACTIVITY_INDICATION_EVENTS.forEach(function (event) {
    window.addEventListener(event, throttle(resetTimer, LIMIT));
  });
};
var _default = monitorUserActivity;
exports.default = _default;